
export const jobSearchTranslations: Record<string, { vi: string, bn: string }> = {
  // Common
  'search': { vi: 'Tìm kiếm', bn: 'অনুসন্ধান' },
  'reset': { vi: 'Xóa tất cả', bn: 'রিসেট করুন' },
  'clear': { vi: 'Xóa', bn: 'মুছে ফেলুন' },
  'apply': { vi: 'Áp dụng', bn: 'প্রয়োগ করুন' },
  'loading': { vi: 'Đang tải...', bn: 'লোড হচ্ছে...' },
  'all': { vi: 'Tất cả', bn: 'সব' },
  'flexible': { vi: 'Linh hoạt', bn: 'নমনীয়' },
  'none': { vi: 'Không', bn: 'নেই' },
  'not_specified': { vi: 'Chưa rõ', bn: 'অজানা' },
  'select_date': { vi: 'Chọn ngày', bn: 'তারিখ নির্বাচন করুন' },
  'select_interview_date': { vi: 'Chọn ngày phỏng vấn', bn: 'সাক্ষাৎকারের তারিখ নির্বাচন করুন' },
  'person': { vi: 'người', bn: 'জন' },
  'round': { vi: 'vòng', bn: 'রাউন্ড' },
  'Trung bình': { vi: 'Trung bình', bn: 'মাঝারি' },
  'Cơ bản': { vi: 'Cơ bản', bn: 'প্রাথমিক' },
  'Không': { vi: 'Không', bn: 'না' },
  'statusPending': { vi: 'Chờ duyệt', bn: 'অনুমোদনের অপেক্ষা' },
  'labelShowOnNewsfeed': { vi: 'Hiển thị thông tin việc làm này lên bảng tin chung (Cần được duyệt)', bn: 'সাধারণ নিউজফিডে এই চাকরির তথ্য প্রদর্শন করুন (অনুমোদন প্রয়োজন)' },
  'dialogNewsfeedTitle': { vi: 'Hiển thị việc làm', bn: 'চাকরি প্রদর্শন' },
  'dialogNewsfeedContent': { vi: 'Bạn có muốn hiển thị thông tin việc làm này lên danh sách Việc làm chung không? (Cần được duyệt)', bn: 'আপনি কি এই চাকরির তথ্য সাধারণ নিউজফিড তালিকায় প্রদর্শন করতে চান? (অনুমোদন প্রয়োজন)' },
  'btnAgree': { vi: 'Đồng ý', bn: 'সহমত' },
  'btnLater': { vi: 'Để sau', bn: 'পরে' },

  // Search Module
  'hero_title': { vi: 'Tìm kiếm việc làm tại Việt Nam', bn: 'ভিয়েতনামে চাকরি খুঁজুন' },
  'hero_subtitle': { vi: 'Hàng ngàn cơ hội việc làm đang chờ bạn', bn: 'হাজার হাজার চাকরির সুযোগ আপনার জন্য অপেক্ষা করছে' },
  'search_placeholder': { vi: 'Tìm theo từ khóa...', bn: 'কীওয়ার্ড দিয়ে খুঁজুন...' },
  'region_placeholder': { vi: 'Tất cả vùng', bn: 'সব অঞ্চল' },
  'salary_placeholder': { vi: 'Mọi mức lương', bn: 'যেকোনো বেতন' },
  'labor_type': { vi: 'Loại hình lao động', bn: 'শ্রমের ধরণ' },
  'all_labor_types': { vi: 'Tất cả loại hình', bn: 'সব ধরণের শ্রম' },
  'skilled_labor': { vi: 'Lao động phổ thông', bn: 'সাধারণ শ্রমিক' },
  'technical_labor': { vi: 'Lao động kỹ thuật', bn: 'প্রযুক্তিগত শ্রমিক' },
  'professional': { vi: 'Kỹ sư, trí thức', bn: 'প্রকৌশলী, বিশেষজ্ঞ' },
  'desired_salary': { vi: 'Mức lương mong muốn', bn: 'কাঙ্ক্ষিত বেতন' },
  'all_salaries': { vi: 'Tất cả mức lương', bn: 'সব বেতন' },
  'salary_under': { vi: 'Từ {val}$ trở xuống', bn: '{val}$ বা তার কম' },
  'filtering_by': { vi: 'Đang lọc theo', bn: 'ফিল্টার করা হচ্ছে' },

  // Sidebar Filters
  'filter_title': { vi: 'Bộ lọc tìm kiếm', bn: 'অনুসন্ধান ফিল্টার' },
  'keyword_search': { vi: 'Tìm kiếm từ khóa', bn: 'কীওয়ার্ড অনুসন্ধান' },
  'keyword_placeholder': { vi: 'Chức danh, kỹ năng, công ty...', bn: 'পদবি, দক্ষতা, কোম্পানি...' },
  'job_type': { vi: 'Loại hình công việc', bn: 'কাজের ধরণ' },
  'visa_detail': { vi: 'Chi tiết loại hình visa', bn: 'ভিসার বিস্তারিত' },
  'all_visa_details': { vi: 'Tất cả chi tiết', bn: 'সব বিস্তারিত' },
  'industry_job': { vi: 'Ngành nghề & Công việc', bn: 'শিল্প ও কাজ' },
  'industry': { vi: 'Ngành nghề', bn: 'শিল্প' },
  'select_industry': { vi: 'Chọn ngành nghề', bn: 'শিল্প নির্বাচন করুন' },
  'all_industries': { vi: 'Tất cả ngành nghề', bn: 'সব শিল্প' },
  'job_detail': { vi: 'Chi tiết công việc', bn: 'কাজের বিস্তারিত' },
  'select_job': { vi: 'Chọn công việc', bn: 'কাজ নির্বাচন করুন' },
  'all_jobs': { vi: 'Tất cả công việc', bn: 'সব কাজ' },
  'work_location': { vi: 'Địa điểm làm việc', bn: 'কাজের অবস্থান' },
  'selected_count': { vi: 'Đã chọn ({count})', bn: 'নির্বাচিত ({count})' },
  'region_name': { vi: 'Vùng {name}', bn: '{name} অঞ্চল' },
  'job_count': { vi: '{count} việc', bn: '{count}টি কাজ' },
  'recruitment_process': { vi: 'Quy trình tuyển dụng', bn: 'নিয়োগ প্রক্রিয়া' },
  'interview_location': { vi: 'Địa điểm phỏng vấn', bn: 'সাক্ষাৎকারের অবস্থান' },
  'select_city': { vi: 'Chọn tỉnh/thành phố', bn: 'শهر নির্বাচন করুন' },
  'all_locations': { vi: 'Tất cả địa điểm', bn: 'সব অবস্থান' },
  'interview_rounds': { vi: 'Số vòng phỏng vấn', bn: 'সাক্ষাৎকারের রাউন্ড সংখ্যা' },
  'select_rounds': { vi: 'Chọn số vòng', bn: 'রাউন্ড নির্বাচন করুন' },
  'interview_date': { vi: 'Ngày phỏng vấn', bn: 'সাক্ষাৎকারের তারিখ' },
  'until_date': { vi: 'Đến ngày', bn: 'তারিখ পর্যন্ত' },
  'exact_date': { vi: 'Đúng ngày', bn: 'সঠিক তারিখ' },
  'from_date': { vi: 'Từ ngày', bn: 'তারিখ থেকে' },
  'flexible_date': { vi: 'Linh hoạt', bn: 'নমনীয়' },
  'flexible_interview': { vi: 'Đủ người thì phỏng vấn', bn: 'পর্যাপ্ত প্রার্থী হলে সাক্ষাৎকার' },
  'salary_benefit': { vi: 'Lương & Đãi ngộ', bn: 'বেতন ও সুবিধা' },
  'salary_month': { vi: 'Lương tháng', bn: 'মাসিক বেতন' },
  'salary_hour': { vi: 'Lương giờ', bn: 'ঘন্টায় বেতন' },
  'salary_year': { vi: 'Lương năm', bn: 'বার্ষিক বেতন' },
  'basic_salary': { vi: 'Lương cơ bản (JPY/tháng)', bn: 'মূল বেতন (JPY/মাস)' },
  'min_actual_salary': { vi: 'Thực lĩnh tối thiểu (JPY/tháng)', bn: 'ন্যূনতম প্রকৃত বেতন (JPY/মাস)' },
  'salary_example': { vi: 'VD: 200,000', bn: 'উদা: ২০০,০০০' },
  'net_salary_example': { vi: 'VD: 160,000', bn: 'উদা: ১৬০,০০০' },
  'annual_income': { vi: 'Thu nhập năm (JPY)', bn: 'বার্ষিক আয় (JPY)' },
  'annual_bonus': { vi: 'Thưởng năm (JPY)', bn: 'বার্ষিক বোনাস (JPY)' },
  'hourly_salary_jpy': { vi: 'Lương giờ (JPY)', bn: 'ঘন্টায় বেতন (JPY)' },
  'fee_level': { vi: 'Mức phí', bn: 'ফি লেভেল' },
  'fees_with_tuition': { vi: 'Phí và vé và học phí (USD)', bn: 'ফি, টিকিট এবং টিউশন (USD)' },
  'fees_no_tuition': { vi: 'Phí và vé không học phí (USD)', bn: 'টিউশন ছাড়া ফি এবং টিকিট (USD)' },
  'fees_with_ticket': { vi: 'Phí có vé (USD)', bn: 'টিকিট সহ ফি (USD)' },
  'fees_no_ticket': { vi: 'Phí không vé (USD)', bn: 'টিকিট ছাড়া ফি (USD)' },
  'family_info': { vi: 'Thông tin gia đình', bn: 'পারিবারিক তথ্য' },
  'marital_status': { vi: 'Tình trạng hôn nhân', bn: 'বৈবাহಿಕ অবস্থা' },
  'select_marital_status': { vi: 'Chọn tình trạng hôn nhân', bn: 'বৈবাহিক অবস্থা নির্বাচন করুন' },
  'single': { vi: 'Độc thân', bn: 'অবিবাহಿತ' },
  'married': { vi: 'Đã kết hôn', bn: 'বিবাহিত' },
  'divorced': { vi: 'Ly hôn', bn: 'বিচ্ছেদ' },
  'children': { vi: 'Con cái', bn: 'সন্তান' },
  'select_children_status': { vi: 'Chọn trạng thái con cái', bn: 'সন্তানের অবস্থা নির্বাচন করুন' },
  'no_children': { vi: 'Chưa có con', bn: 'সন্তান নেই' },
  'has_children': { vi: 'Đã có con', bn: 'সন্তান আছে' },
  'health_habits': { vi: 'Sức khỏe & Thói quen', bn: 'স্বাস্থ্য এবং অভ্যাস' },
  'religion': { vi: 'Tôn giáo', bn: 'ধর্ম' },
  'select_religion': { vi: 'Chọn tôn giáo', bn: 'ধর্ম নির্বাচন করুন' },
  'muslim': { vi: 'Hồi giáo', bn: 'ইসলাম' },
  'hindu': { vi: 'Hindu', bn: 'হিন্দু' },
  'christian': { vi: 'Thiên chúa giáo', bn: 'খ্রিস্টান' },
  'buddhist': { vi: 'Phật giáo', bn: 'বৌদ্ধ' },
  'other_religion': { vi: 'Khác', bn: 'অন্যান্য' },
  'dominant_hand': { vi: 'Tay thuận', bn: 'প্রধান হাত' },
  'select_dominant_hand': { vi: 'Chọn tay thuận', bn: 'হাত নির্বাচন করুন' },
  'right_hand': { vi: 'Tay phải', bn: 'ডান হাত' },
  'left_hand': { vi: 'Tay trái', bn: 'বাম হাত' },
  'both_hands': { vi: 'Cả hai tay', bn: 'উভয় হাত' },
  'smoking_habit': { vi: 'Thói quen hút thuốc', bn: 'ধূমপানের অভ্যাস' },
  'select_smoking_status': { vi: 'Chọn thói quen hút thuốc', bn: 'ধূমপানের অভ্যাস নির্বাচন করুন' },
  'no_smoking': { vi: 'Không hút thuốc', bn: 'ধূমপান করেন না' },
  'smoking': { vi: 'Có hút thuốc', bn: 'ধূমপান করেন' },
  'drinking_habit': { vi: 'Thói quen uống rượu', bn: 'মদ্যপানের অভ্যাস' },
  'select_drinking_status': { vi: 'Chọn thói quen uống rượu', bn: 'মদ্যপানের অভ্যাস নির্বাচন করুন' },
  'no_drinking': { vi: 'Không uống rượu', bn: 'মদ্যপান করেন না' },
  'drinking': { vi: 'Có uống rượu', bn: 'মদ্যপান করেন' },
  'Độc thân': { vi: 'Độc thân', bn: 'অবিবাহিত' },
  'Đã kết hôn': { vi: 'Đã kết hôn', bn: 'বিবাহিত' },
  'Ly hôn': { vi: 'Ly hôn', bn: 'বিচ্ছেদ' },
  'Chưa có con': { vi: 'Chưa có con', bn: 'সন্তান নেই' },
  'Đã có con': { vi: 'Đã có con', bn: 'সন্তান আছে' },
  'Có y tế': { vi: 'Có y tế', bn: 'চিকিৎসা সুবিধা আছে' },
  'Có': { vi: 'Có', bn: 'হ্যাঁ' },
  'Đã từng đi': { vi: 'Đã từng đi', bn: 'আগে করেছেন' },
  'Không bắt buộc': { vi: 'Không bắt buộc', bn: 'ঐচ্ছিক' },
  'international_exp': { vi: 'Kinh nghiệm quốc tế', bn: 'আন্তর্জাতিক trải nghiệm' },
  'worked_abroad': { vi: 'Đã từng làm việc nước ngoài', bn: 'বিদেশে কাজ করার অভিজ্ঞতা' },
  'select_abroad_status': { vi: 'Chọn trạng thái', bn: 'অবস্থা নির্বাচন করুন' },
  'never': { vi: 'Chưa từng', bn: 'কখনো না' },
  'ever': { vi: 'Đã từng', bn: 'আগে করেছেন' },
  'english_level': { vi: 'Trình độ Tiếng Anh', bn: 'ইংরেজি স্তর' },
  'select_english_level': { vi: 'Chọn trình độ tiếng Anh', bn: 'ইংরেজি স্তর নির্বাচন করুন' },
  'basic_english': { vi: 'Cơ bản', bn: 'প্রাথমিক' },
  'good_communication': { vi: 'Giao tiếp tốt', bn: 'ভালো যোগাযোগ' },
  'ielts_pte': { vi: 'IELTS/PTE', bn: 'IELTS/PTE' },
  'experience': { vi: 'Kinh nghiệm', bn: 'অভিজ্ঞতা' },
  'experience_requirement': { vi: 'Yêu cầu kinh nghiệm', bn: 'অভিজ্ঞতার প্রয়োজন' },
  'select_exp_job': { vi: 'Chọn công việc', bn: 'কাজ নির্বাচন করুন' },
  'all_exp_jobs': { vi: 'Tất cả công việc', bn: 'সব কাজ' },
  'years_of_experience': { vi: 'Số năm kinh nghiệm', bn: 'অভিজ্ঞতার বছর' },
  'select_years': { vi: 'Chọn số năm', bn: 'বছর নির্বাচন করুন' },
  'candidate_requirement': { vi: 'Yêu cầu ứng viên', bn: 'প্রার্থীর প্রয়োজনীয়তা' },
  'gender_and_target': { vi: 'Giới tính, đối tượng', bn: 'লিঙ্গ, লক্ষ্য' },
  'male': { vi: 'Nam', bn: 'পুরুষ' },
  'female': { vi: 'Nữ', bn: 'নারী' },
  'male_and_female': { vi: 'Cả nam và nữ', bn: 'পুরুষ ও নারী উভয়ই' },
  'couple': { vi: 'Cặp đôi', bn: 'জুটি' },
  'married_couple': { vi: 'Vợ chồng', bn: 'বিবাহিত দম্পতি' },
  'age': { vi: 'Tuổi', bn: 'বয়স' },
  'age_range': { vi: '{min}-{max} tuổi', bn: '{min}-{max} বছর' },
  'height_cm': { vi: 'Chiều cao (cm)', bn: 'উচ্চতা (সেমি)' },
  'height_range': { vi: '{min}-{max} cm', bn: '{min}-{max} সেমি' },
  'weight_kg': { vi: 'Cân nặng (kg)', bn: 'ওজন (কেজি)' },
  'weight_range': { vi: '{min}-{max} kg', bn: '{min}-{max} কেজি' },
  'vision_requirement': { vi: 'Yêu cầu thị lực', bn: 'দৃষ্টিশক্তির প্রয়োজনীয়তা' },
  'select_vision_req': { vi: 'Chọn yêu cầu thị lực', bn: 'দৃষ্টিশক্তির প্রয়োজনীয়তা নির্বাচন করুন' },
  'tattoo_requirement': { vi: 'Yêu cầu hình xăm', bn: 'ট্যাটু প্রয়োজনীয়তা' },
  'select_tattoo_req': { vi: 'Chọn yêu cầu hình xăm', bn: 'ট্যাটু প্রয়োজনীয়তা নির্বাচন করুন' },
  'japanese_level': { vi: 'Trình độ tiếng Nhật', bn: 'জাপানি ভাষা স্তর' },
  'no_japanese_required': { vi: 'Không yêu cầu tiếng Nhật', bn: 'জাপানি ভাষার প্রয়োজন নেই' },
  'jlpt_requirement': { vi: 'Yêu cầu JLPT', bn: 'JLPT প্রয়োজনীয়তা' },
  'select_jlpt_all': { vi: 'Tất cả JLPT', bn: 'সব JLPT' },
  'kaiwa_requirement': { vi: 'Yêu cầu Kaiwa', bn: 'কাইওয়া প্রয়োজনীয়তা' },
  'select_kaiwa_all': { vi: 'Tất cả Kaiwa', bn: 'সব কাইওয়া' },
  'education': { vi: 'Học vấn', bn: 'শিক্ষা' },
  'select_education': { vi: 'Chọn học vấn', bn: 'শিক্ষা নির্বাচন করুন' },
  'other_skill_requirement': { vi: 'Yêu cầu năng lực khác', bn: 'অন্যান্য দক্ষতার প্রয়োজনীয়তা' },
  'ginou_expiry_requirement': { vi: 'Yêu cầu hạn Ginou còn', bn: 'গিনু সার্টিফিকেটের মেয়াদ' },
  'select_time_period': { vi: 'Chọn thời gian', bn: 'সময় নির্বাচন করুন' },
  'company_arrival_time_requirement': { vi: 'Yêu cầu thời điểm về công ty', bn: 'কোম্পানিতে আগমনের thời điểm' },
  'select_arrival_time': { vi: 'Chọn thời điểm', bn: 'সময় নির্বাচন করুন' },
  'work_shift': { vi: 'Ca làm việc', bn: 'কাজের শিফট' },
  'select_work_shift': { vi: 'Chọn ca làm việc', bn: 'শিফট নির্বাচন করুন' },
  'min_quantity': { vi: 'Số lượng tuyển tối thiểu', bn: 'ন্যূনতম নিয়োগ সংখ্যা' },
  'quantity_placeholder': { vi: 'Nhập số người', bn: 'সংখ্যা লিখুন' },
  'special_conditions': { vi: 'Điều kiện đặc biệt', bn: 'বিশেষ শর্তাবলী' },
  'apply_results_count': { vi: 'Áp dụng ({count})', bn: 'প্রয়োগ করুন ({count})' },
  'clear_all': { vi: 'Xóa', bn: 'মুছে ফেলুন' },

  // Search Results
  'results_count': { vi: 'Kết quả ({count})', bn: 'ফলাফল ({count}টি)' },
  'filter': { vi: 'Lọc', bn: 'ফিল্টার' },
  'filter_sheet_title': { vi: 'Bộ lọc tìm kiếm', bn: 'অনুসন্ধান ফিল্টার' },
  'filter_sheet_desc': { vi: 'Tinh chỉnh kết quả tìm kiếm của bạn.', bn: 'আপনার অনুসন্ধানের ফলাফলগুলি পরিমার্জন করুন।' },
  'sort_by': { vi: 'Sắp xếp theo', bn: 'সাজানোর ধরণ' },
  'sort_newest': { vi: 'Mới nhất', bn: 'সর্বশেষ' },
  'sort_salary_desc': { vi: 'Lương cơ bản: Cao > Thấp', bn: 'মূল বেতন: উচ্চ > নিম্ন' },
  'sort_salary_asc': { vi: 'Lương cơ bản: Thấp > Cao', bn: 'মূল বেতন: নিম্ন > উচ্চ' },
  'sort_net_salary_desc': { vi: 'Thực lĩnh: Cao > Thấp', bn: 'প্রকৃত বেতন: উচ্চ > নিম্ন' },
  'sort_net_salary_asc': { vi: 'Thực lĩnh: Thấp > Cao', bn: 'প্রকৃত বেতন: নিম্ন > উচ্চ' },
  'sort_fee_asc': { vi: 'Phí thấp > Cao', bn: 'ফি নিম্ন > উচ্চ' },
  'sort_fee_desc': { vi: 'Phí cao > Thấp', bn: 'ফি উচ্চ > নিম্ন' },
  'sort_interview_asc': { vi: 'Ngày phỏng vấn: Gần nhất', bn: 'সাক্ষাৎকারের তারিখ: নিকটতম' },
  'sort_interview_desc': { vi: 'Ngày phỏng vấn: Xa nhất', bn: 'সাক্ষাৎকারের তারিখ: দূরতম' },
  'sort_image': { vi: 'Ưu tiên có ảnh', bn: 'ছবি আছে এমন' },
  'sort_video': { vi: 'Ưu tiên có video', bn: 'ভিডিও আছে এমন' },
  'sort_hot': { vi: 'Độ hot', bn: 'জনপ্রিয়তা' },
  'sort_applicants': { vi: 'Nhiều người ứng tuyển', bn: 'সবচেয়ে বেশি আবেদনকারী' },
  'no_jobs_found': { vi: 'Không tìm thấy công việc nào phù hợp.', bn: 'কোনো উপযুক্ত কাজ পাওয়া যায়নি।' },
  'try_changing_filters': { vi: 'Hãy thử thay đổi bộ lọc hoặc tìm kiếm lại.', bn: 'ফিল্টার পরিবর্তন বা আবার অনুসন্ধান করার চেষ্টা করুন।' },
  'load_more': { vi: 'Tải thêm', bn: 'আরো লোড করুন' },

  // Job Card
  'job_id': { vi: 'Mã việc làm:', bn: 'চাকরি আইডি:' },
  'posted_at': { vi: 'Đăng lúc:', bn: 'পোস্ট করা হয়েছে:' },
  'income_card': { vi: 'Thu nhập:', bn: 'আয়:' },
  'allowance_card': { vi: 'Trợ cấp:', bn: 'ভাতা:' },
  'interview_date_card': { vi: 'Ngày phỏng vấn:', bn: 'সাক্ষাৎকারের তারিখ:' },
  'quantity': { vi: 'Số lượng:', bn: 'পরিমাণ:' },
  'people': { vi: 'người', bn: 'জন' },
  'save': { vi: 'Lưu', bn: 'সংরক্ষণ করুন' },
  'saved': { vi: 'Đã lưu', bn: 'সংরক্ষিত' },
  'apply_now': { vi: 'Ứng tuyển', bn: 'আবেদন করুন' },
  'applied': { vi: 'Đã ứng tuyển', bn: 'আবেদন করা হয়েছে' },
  'interview_flexible': { vi: 'Khi đủ ứng viên', bn: 'পর্যাপ্ত প্রার্থী হলে' },
  // Job Card Actions & Dialogs
  'apply_success_title': { vi: 'Ứng tuyển thành công!', bn: 'আবেদন সফল হয়েছে!' },
  'apply_success_desc': { vi: 'Hồ sơ của bạn đã được gửi cho công việc "{title}".', bn: 'আপনার প্রোফাইল "{title}" চাকরির জন্য পাঠানো হয়েছে।' },
  'view_profile': { vi: 'Xem hồ sơ', bn: 'প্রোফাইল দেখুন' },
  'category': { vi: 'Phân loại:', bn: 'বিভাগ:' },
  'not_logged_in': { vi: 'Bạn chưa đăng nhập', bn: 'আপনি লগ ইন করেননি' },
  'not_logged_in_desc': { vi: 'Bạn cần đăng nhập để ứng tuyển, bạn có muốn đăng nhập không?', bn: 'আবেদন করতে আপনাকে লগ ইন করতে হবে, আপনি কি লগ ইন করতে চান?' },
  'later': { vi: 'Để sau', bn: 'পরে' },
  'agree': { vi: 'Đồng ý', bn: 'সম্মত' },
  'profile_incomplete': { vi: 'Hồ sơ của bạn chưa hoàn thiện', bn: 'আপনার প্রোফাইল অসম্পূর্ণ' },
  'profile_incomplete_desc': { vi: 'Hồ sơ của bạn chưa hoàn thiện. Để có thể ứng tuyển, bạn cần điền tối thiểu 50% thông tin profile. Bạn có muốn cập nhật hồ sơ ngay bây giờ không?', bn: 'আপনার প্রোফাইল অসম্পূর্ণ। আবেদন করার জন্য আপনার প্রোফাইলের ন্যূনতম ৫০% তথ্য পূরণ করতে হবে। আপনি কি এখনই আপনার প্রোফাইল আপডেট করতে চান?' },
  'agree_update': { vi: 'Đồng ý, cập nhật', bn: 'হ্যাঁ, আপডেট করুন' },
  'update_success_title': { vi: 'Cập nhật thành công!', bn: 'আপডেট সফল হয়েছে!' },
  'update_success_desc': { vi: 'Thông tin của bạn đã được lưu. Giờ bạn có thể ứng tuyển.', bn: 'আপনার তথ্য সংরক্ষণ করা হয়েছে। এখন আপনি আবেদন করতে পারেন।' },
  'interview_date_card_short': { vi: 'Ngày PV:', bn: 'সাক্ষাৎকারের তারিখ:' },
  'net_income_card': { vi: 'Thực lĩnh:', bn: 'প্রকৃত বেতন:' },
  'labor_technical': { vi: 'Lao động Kỹ thuật', bn: 'প্রযুক্তিগত শ্রম' },
  // Extra
  'test_language': { vi: 'Kiểm thử ngôn ngữ', bn: 'ভাষা পরীক্ষা করুন' },
  'switch_to_vi': { vi: 'Xem tiếng Việt', bn: 'ভিয়েতনামী দেখুন' },
  'switch_to_bn': { vi: 'Xem tiếng Bangladesh', bn: 'বাংলাদেশি দেখুন' },

  // Job List Page
  'job_list_technical_labor': { vi: 'Việc làm lao động kỹ thuật', bn: 'প্রযুক্তিগত শ্রম কাজ' },
  'job_list_suggestions': { vi: 'Xem gợi ý việc làm dành riêng cho bạn', bn: 'আপনার জন্য নির্দিষ্ট কাজের পরামর্শ দেখুন' },
  'job_list_login_desc': { vi: 'Đăng nhập hoặc tạo hồ sơ để nhận được những gợi ý phù hợp nhất từ HelloJob AI.', bn: 'HelloJob AI থেকে সেরা পরামর্শ পেতে লগ ইন করুন বা একটি প্রোফাইল তৈরি করুন।' },
  'job_list_login_btn': { vi: 'Đăng nhập / Đăng ký', bn: 'লগ ইন / নিবন্ধন করুন' },
  'decree_219_intro': { vi: 'Theo khoản 4, điều 3, Nghị định số: 219/2025/NĐ-CP của Chính phủ nước Cộng hoà Xã hội Chủ nghĩa Việt Nam, ban hành ngày 07 tháng 8 năm 2025, lao động kỹ thuật thuộc một trong các trường hợp sau đây:', bn: 'ভিয়েতনামের সমাজতান্ত্রিক প্রজাতন্ত্রের সরকারের 07 আগস্ট 2025-এ জারি করা ডিক্রি নং: 219/2025/ND-CP এর 3 ধারার 4 অনুচ্ছেদ অনুসারে, প্রযুক্তিগত শ্রম নিচের যে কোনো একটির অন্তর্গত:' },
  'decree_219_a': { vi: 'a) Được đào tạo ít nhất 1 năm và có ít nhất 2 năm kinh nghiệm phù hợp với vị trí công việc mà người lao động nước ngoài dự kiến làm việc tại Việt Nam;', bn: 'a) বিদেশীকর্মী ভিয়েতনামে যে পদে কাজ করার পরিকল্পনা করছেন, সেই পদের জন্য কমপক্ষে 1 বছরের প্রশিক্ষণ এবং কমপক্ষে 2 বছরের প্রাসঙ্গিক অভিজ্ঞতা থাকতে হবে;' },
  'decree_219_b': { vi: 'b) Có ít nhất 3 năm kinh nghiệm làm việc phù hợp với vị trí công việc mà người lao động nước ngoài dự kiến làm việc tại Việt Nam.', bn: 'b) বিদেশীকর্মী ভিয়েতনামে যে পদে কাজ করার পরিকল্পনা করছেন, সেই পদের জন্য কমপক্ষে 3 বছরের প্রাসঙ্গিক কাজের অভিজ্ঞতা থাকতে হবে।' },
  'decree_219_warning': { vi: 'Vui lòng tuân thủ quy định về đào tạo và kinh nghiệm nếu bạn muốn đến Việt Nam làm việc theo loại hình lao động này', bn: 'আপনি যদি এই ধরণের শ্রমে কাজ করার জন্য ভিয়েতনামে আসতে চান তবে অনুগ্রহ করে প্রশিক্ষণ এবং অভিজ্ঞতার নিয়মাবলী মেনে চলুন' },
  'view_all': { vi: 'Xem tất cả', bn: 'সবগুলো দেখুন' },
  'back_to_jobs': { vi: 'Quay lại trang Việc làm', bn: 'কাজের পেজে ফিরে যান' },
  'back_to_my_jobs': { vi: 'Quay lại Việc làm của tôi', bn: 'আমার কাজের পেজে ফিরে যান' },

  // Job Details Page
  'job_details_id': { vi: 'Mã việc làm:', bn: 'চাকরি আইডি:' },
  'job_details_posted': { vi: 'Đăng lúc:', bn: 'পোস্ট করা হয়েছে:' },
  'job_details_loading': { vi: 'Đang tải...', bn: 'লোড হচ্ছে...' },
  'job_details_saved': { vi: 'Việc đã lưu', bn: 'সংরক্ষিত কাজ' },
  'job_details_save': { vi: 'Lưu việc làm', bn: 'কাজ সংরক্ষণ করুন' },
  'job_details_basic_info': { vi: 'Thông tin cơ bản', bn: 'মৌলিক তথ্য' },
  'job_details_visa_type': { vi: 'Loại Visa', bn: 'ভিসার ধরণ' },
  'job_details_visa_detail': { vi: 'Chi tiết Visa', bn: 'ভিসার বিস্তারিত' },
  'job_details_industry': { vi: 'Ngành nghề', bn: 'শিল্প' },
  'job_details_interview_location': { vi: 'Nơi phỏng vấn', bn: 'সাক্ষাৎকারের অবস্থান' },
  'job_details_online': { vi: 'Online', bn: 'অনলাইন' },
  'job_details_vietnamese': { vi: 'Tiếng Việt', bn: 'ভিয়েতনামী ভাষা' },
  'job_details_english': { vi: 'Tiếng Anh', bn: 'ইংরেজি ভাষা' },
  'job_details_english_default': { vi: 'TOEIC +400 hoặc Giao tiếp: Trung bình', bn: 'TOEIC +400 অথবা যোগাযোগ: মাঝারি' },
  'job_details_religion': { vi: 'Tôn giáo', bn: 'ধর্ম' },
  'job_details_meals': { vi: 'Bữa ăn', bn: 'খাবার' },
  'job_details_shuttle': { vi: 'Xe đưa đón', bn: 'শাটল বাস' },
  'job_details_gender': { vi: 'Giới tính', bn: 'লিঙ্গ' },
  'job_details_quantity': { vi: 'Số lượng', bn: 'পরিমাণ' },
  'job_details_age_req': { vi: 'Yêu cầu tuổi', bn: 'বয়সের প্রয়োজনীয়তা' },
  'job_details_interview_rounds': { vi: 'Số vòng', bn: 'রাউন্ডের সংখ্যা' },
  'job_details_rounds': { vi: 'vòng', bn: 'রাউন্ড' },
  'job_details_fees': { vi: 'Phí và học phí', bn: 'ফি এবং টিউশন' },
  'job_details_full_package': { vi: 'Trọn gói', bn: 'সব মিলিয়ে' },
  'job_details_with_ticket': { vi: 'Có vé', bn: 'টিকিট সহ' },
  'job_details_no_ticket': { vi: 'Không vé', bn: 'টিকিট ছাড়া' },
  'fee_all_in': { vi: 'Trọn gói', bn: 'সব মিলিয়ে' },
  'contact_for_consultation': { vi: 'Liên hệ tư vấn', bn: 'অংশীদারের সাথে যোগাযোগ করুন' },
  'job_details_contact_consultant': { vi: 'Liên hệ tư vấn', bn: 'অংশীদারের সাথে যোগাযোগ করুন' },
  'job_details_detailed_req': { vi: 'Yêu cầu chi tiết', bn: 'বিস্তারিত প্রয়োজনীয়তা' },
  'job_details_edu_req': { vi: 'Yêu cầu học vấn', bn: 'শিক্ষাগত প্রয়োজনীয়তা' },
  'job_details_exp_years': { vi: 'Số năm kinh nghiệm', bn: 'অভিজ্ঞতার বছর' },
  'job_details_height': { vi: 'Chiều cao', bn: 'উচ্চতা' },
  'job_details_weight': { vi: 'Cân nặng', bn: 'ওজন' },
  'job_details_hepb': { vi: 'Viêm gan B', bn: 'হেপাটাইটিস বি' },
  'job_details_no_hepb': { vi: 'Không nhận viêm gan B', bn: 'হেপাটাইটিস বি গ্রহণ করা হয় না' },
  'job_details_tattoo': { vi: 'Hình xăm', bn: 'ট্যাটু' },
  'job_details_vision': { vi: 'Yêu cầu thị lực', bn: 'দৃষ্টিশক্তির প্রয়োজনীয়তা' },
  'job_details_handedness': { vi: 'Tay thuận', bn: 'প্রধান হাত' },
  'job_details_other_habits': { vi: 'Thói quen khác', bn: 'অন্যান্য অভ্যাস' },
  'job_details_accommodation': { vi: 'Chỗ ở', bn: 'বাসস্থান' },
  'job_details_overtime': { vi: 'Tăng ca', bn: 'ওভারটাইম' },
  'job_details_health_policy': { vi: 'Chế độ y tế', bn: 'মেডিকেল সুবিধা' },
  'job_details_training': { vi: 'Đào tạo', bn: 'প্রশিক্ষণ' },
  'job_details_interview_format': { vi: 'Hình thức phỏng vấn', bn: 'সাক্ষাৎকারের ধরণ' },
  'job_details_family_exp_info': { vi: 'Thông tin Gia đình & Kinh nghiệm', bn: 'পারিবারিক এবং অভিজ্ঞতার তথ্য' },
  'job_details_child_support': { vi: 'Trợ cấp con của nhân viên', bn: 'কর্মচারীর সন্তানের ভাতা' },
  'job_details_worked_countries': { vi: 'Các nước đã làm', bn: 'কাজ করা দেশ' },
  'job_details_leave_policy': { vi: 'Nghỉ phép', bn: 'ছুটি' },
  'job_details_marital_status': { vi: 'Tình trạng hôn nhân', bn: 'বৈবাহিক অবস্থা' },
  'job_details_children_status': { vi: 'Con cái', bn: 'সন্তান' },
  'job_details_policy_support': { vi: 'Chính sách & Hỗ trợ', bn: 'নীতি ও সহায়তা' },
  'job_details_description_notes': { vi: 'Mô tả công việc & Ghi chú', bn: 'কাজের বিবরণ এবং নোট' },
  'job_details_benefits': { vi: 'Quyền lợi & Chế độ', bn: 'সুবিধা এবং নীতি' },
  'job_details_media': { vi: 'Hình ảnh & Video công việc', bn: 'চাকরির ছবি ও ভিডিও' },
  'job_details_video_section': { vi: 'Video công việc', bn: 'কাজের ভিডিও' },
  'job_details_image_section': { vi: 'Hình ảnh công việc', bn: 'কাজের ছবি' },
  'job_details_salary_section': { vi: 'Mức lương', bn: 'বেতন' },
  'job_details_expected_income': { vi: 'Thu nhập dự kiến', bn: 'প্রত্যাশিত আয়' },
  'job_details_departure_fee': { vi: 'Phí xuất cảnh dự kiến', bn: 'প্রত্যাশিত প্রস্থানের ফি' },
  'job_details_download': { vi: 'Tải xuống chi tiết', bn: 'বিস্তারিত ডাউনলোড করুন' },
  'job_details_share': { vi: 'Chia sẻ ngay', bn: 'এখুনি শেয়ার করুন' },
  'job_details_share_desc': { vi: 'Giới thiệu cho bạn bè của bạn', bn: 'আপনার বন্ধুদের সুপারিশ করুন' },
  'job_details_copied_title': { vi: 'Đã sao chép liên kết!', bn: 'লিঙ্ক কপি করা হয়েছে!' },
  'job_details_copied_desc': { vi: 'Bạn có thể dán và chia sẽ liên kết việc làm này.', bn: 'আপনি এই চাকরির লিঙ্ক পেস্ট এবং শেয়ার করতে পারেন।' },
  'job_details_share_text': { vi: 'Hãy xem công việc này trên HelloJob:', bn: 'হ্যালোজবে এই কাজটি দেখুন:' },
  'usd_bdt_rate_updated': { vi: 'Tỷ giá hối đoái USD/BDT được cập nhật vào:', bn: 'USD/BDT বিনিময় হার আপডেট করা হয়েছে:' },
  'job_details_experience': { vi: 'Kinh nghiệm', bn: 'অভিজ্ঞতা' },
  'job_details_smoking_habit': { vi: 'Thói quen hút thuốc', bn: 'ধূমপানের অভ্যাস' },
  'job_details_drinking_habit': { vi: 'Thói quen uống rượu', bn: 'মদ্যপানের অভ্যাস' },
  'job_details_worked_abroad': { vi: 'Đã từng làm việc nước ngoài', bn: 'বিদেশে কাজ করার অভিজ্ঞতা' },
  'introVideo': { vi: 'Video giới thiệu', bn: 'ভূমিকা ভিডিও' },
  'skillVideo1': { vi: 'Video tay nghề 1', bn: 'দক্ষতা ভিডিও ১' },
  'skillVideo2': { vi: 'Video tay nghề 2', bn: 'দক্ষতা ভিডিও ২' },
  'skillVideo3': { vi: 'Video tay nghề 3', bn: 'দক্ষতা ভিডিও ৩' },
  'office': { vi: 'Ảnh văn phòng', bn: 'অফিসের ছবি' },
  'workshop': { vi: 'Nhà xưởng / Công trường', bn: 'ওয়ার্কশপ / সাইট' },
  'accommodation': { vi: 'Ký túc xá / Nhà ở', bn: 'থাকার জায়গা' },
  'environment': { vi: 'Môi trường làm việc', bn: 'কাজের পরিবেশ' },
  'companyActivities': { vi: 'Hoạt động công ty', bn: 'কোম্পানি কার্যক্রম' },
  'staff': { vi: 'Cán bộ nhân viên', bn: 'কর্মকর্তা ও কর্মচারী' },

  // Profile Generation Dialogs
  'profile_create_method': { vi: 'Chọn phương thức tạo hồ sơ', bn: 'প্রোফাইল তৈরির পদ্ধতি বেছে নিন' },
  'profile_create_purpose': { vi: 'Bạn muốn tạo hồ sơ để làm gì?', bn: 'আপনি কীসের জন্য একটি প্রোফাইল তৈরি করতে চান?' },
  'profile_quick_create': { vi: 'Tạo nhanh', bn: 'দ্রুত তৈরি করুন' },
  'profile_quick_create_desc': { vi: 'Để HelloJob AI gợi ý việc làm phù hợp cho bạn ngay lập tức.', bn: 'হ্যালোজব এআইকে অবিলম্বে আপনার জন্য উপযুক্ত কাজের পরামর্শ দিতে দিন।' },
  'profile_detail_create': { vi: 'Tạo chi tiết', bn: 'বিস্তারিতভাবে তৈরি করুন' },
  'profile_detail_create_desc': { vi: 'Để hoàn thiện hồ sơ và sẵn sàng ứng tuyển vào công việc mơ ước.', bn: 'আপনার প্রোফাইল সম্পূর্ণ করুন এবং আপনার স্বপ্নের চাকরিতে আবেদন করার জন্য প্রস্তুত হন।' },
  'labor_type_selection': { vi: 'Chọn loại hình lao động', bn: 'শ্রমের ধরণ নির্বাচন করুন' },
  'labor_type_desc': { vi: 'Hãy chọn loại hình phù hợp nhất với trình độ và mong muốn của bạn.', bn: 'যে ধরণটি আপনার যোগ্যতা এবং ইচ্ছার জন্য সবচেয়ে উপযুক্ত তা বেছে নিন।' },
  'action_back': { vi: 'Quay lại', bn: 'ফিরে যান' },
  'profile_create_for_jobs': { vi: 'Tạo hồ sơ để được hiển thị việc làm phù hợp', bn: 'উপযুক্ত কাজ দেখতে একটি প্রোফাইল তৈরি করুন' },
  'profile_complete_desc': { vi: 'Hoàn thiện hồ sơ của bạn để nhận được những gợi ý việc làm phù hợp nhất từ HelloJob AI.', bn: 'HelloJob AI থেকে সেরা কাজের সুপারিশ পেতে আপনার প্রোফাইলটি সম্পূর্ণ করুন৷' },
  'profile_quick_create_btn': { vi: 'Tạo hồ sơ nhanh', bn: 'দ্রুত প্রোফাইল তৈরি করুন' },
  'profile_detail_create_btn': { vi: 'Tạo hồ sơ chi tiết', bn: 'বিস্তারিত প্রোফাইল তৈরি করুন' },
  'profile_how_create_detail': { vi: 'Bạn muốn tạo hồ sơ chi tiết bằng cách nào?', bn: 'আপনি কীভাবে একটি বিশদ প্রোফাইল তৈরি করতে চান?' },
  'profile_use_ai': { vi: 'Dùng AI', bn: 'AI ব্যবহার করুন' },
  'profile_ai_desc': { vi: 'Tải lên CV, AI sẽ tự động điền thông tin.', bn: 'জীবনবৃত্তান্ত আপলোড করুন, AI স্বয়ংক্রিয়ভাবে তথ্য পূরণ করবে।' },
  'profile_manual': { vi: 'Thủ công', bn: 'কায়িক' },
  'profile_manual_desc': { vi: 'Tự điền thông tin vào biểu mẫu chi tiết.', bn: 'বিস্তারিত ফর্মে তথ্য পূরণ করুন।' },
  'select_visa_type_detail': { vi: 'Chọn loại {type}', bn: '{type} প্রকার নির্বাচন করুন' },
  'select_visa_type_desc': { vi: 'Chọn loại hình chi tiết để tiếp tục.', bn: 'চালিয়ে যেতে বিস্তারিত প্রকার নির্বাচন করুন।' },
  'tts_desc': { vi: 'Lao động phổ thông, 18-40 tuổi.', bn: 'অদক্ষ শ্রম, বয়স 18-40 বছর।' },
  'kndd_desc': { vi: 'Lao động có hoặc cần thi tay nghề.', bn: 'পেশাদার বা দক্ষতা পরীক্ষা প্রয়োজন এমন শ্রম।' },
  'kstt_desc': { vi: 'Tốt nghiệp CĐ, ĐH, có thể định cư.', bn: 'কলেজ বা বিশ্ববিদ্যালয় স্নাতক, স্থায়ীভাবে বসবাসের সুযোগ।' },
  'unlogged_alert_title': { vi: 'Bạn chưa đăng nhập', bn: 'আপনি লগ ইন করেননি' },
  'unlogged_alert_desc': { vi: 'Bạn cần có tài khoản để lưu các lựa chọn và xem việc làm phù hợp. Đi đến trang đăng ký/đăng nhập?', bn: 'আপনার পছন্দগুলি সংরক্ষণ করতে এবং উপযুক্ত চাকরি দেখতে আপনার একটি অ্যাকাউন্ট প্রয়োজন। নিবন্ধন/লগইন পৃষ্ঠায় যেতে চান?' },
  'alert_deny': { vi: 'Từ chối', bn: 'প্রত্যাখ্যান করুন' },
  'alert_accept': { vi: 'Đồng ý', bn: 'সম্মত' },
  'job_details_applied': { vi: 'Đã ứng tuyển', bn: 'আবেদন করা হয়েছে' },
  'job_details_apply_now': { vi: 'Ứng tuyển ngay', bn: 'এখনই আবেদন করুন' },
  'job_details_net_salary': { vi: 'Thực lĩnh', bn: 'প্রকৃত বেতন' },
  'job_details_annual_income': { vi: 'Thu nhập năm', bn: 'বার্ষিক আয়' },
  'job_details_bonus': { vi: 'Thưởng', bn: 'বোনাস' },
  'job_details_allowance_section': { vi: 'Trợ cấp', bn: 'ভাতা' },
  'job_details_allowances': { vi: 'Các khoản trợ cấp', bn: 'ভাতা সমূহ' },
  'job_details_consultant': { vi: 'Đối tác', bn: 'অংশীদার' },
  'job_details_related_jobs': { vi: 'Có thể bạn quan tâm', bn: 'আপনি পছন্দ করতে পারেন এমন কাজ' },
  'job_details_no_suggestions': { vi: 'Không có gợi ý nào. Hãy xem thêm các công việc khác để chúng tôi hiểu bạn hơn!', bn: 'কোনো পরামর্শ নেই। আমরা আপনাকে আরও ভালোভাবে বুঝতে আরও চাকরি দেখুন!' },
  'job_details_suggestions_for_you': { vi: 'Gợi ý cho bạn', bn: 'আপনার জন্য পরামর্শ' },
  'job_details_no_profile_suggestions': { vi: 'Không có gợi ý nào dựa trên hồ sơ của bạn. Hãy cập nhật hồ sơ để nhận gợi ý tốt hơn.', bn: 'আপনার প্রোফাইলের ওপর ভিত্তি করে কোনো পরামর্শ নেই। আরও ভালো পরামর্শ পেতে আপনার প্রোফাইল আপডেট করুন।' },
  'profile_incomplete_title': { vi: 'Hồ sơ của bạn chưa hoàn thiện', bn: 'আপনার প্রোফাইল অসম্পূর্ণ' },
  'job_details_income_section': { vi: 'Thông tin thu nhập', bn: 'আয় তথ্য' },
  'fee': { vi: 'Phí', bn: 'ফি' },
  'unknown': { vi: 'Chưa rõ', bn: 'অজানা' },
  'fee_with_tuition': { vi: 'Đã bao gồm học phí', bn: 'টিউশন সহ' },
  'fee_no_tuition': { vi: 'Không bao gồm học phí', bn: 'টিউশন ছাড়া' },
  'fee_with_ticket': { vi: 'Đã bao gồm vé máy bay', bn: 'টিকিট সহ' },
  'fee_no_ticket': { vi: 'Không bao gồm vé máy bay', bn: 'টিকিট ছাড়া' },
  'net_salary_card': { vi: 'Thực lĩnh:', bn: 'প্রকৃত বেতন:' },
  'job_details_interview_date': { vi: 'Ngày phỏng vấn', bn: 'সাক্ষাৎকারের তারিখ' },
  'job_details_basic_salary': { vi: 'Lương cơ bản', bn: 'মূল বেতন' },
  'contact_us': { vi: 'Liên hệ', bn: 'যোগাযোগ করুন' },
  'open_chat': { vi: 'Liên hệ Tổng đối tác', bn: 'মাস্টার অংশীদারের সাথে যোগাযোগ করুন' },
  'close_chat': { vi: 'Đóng Chat', bn: 'চ্যাট বন্ধ করুন' },

  // Locations & Countries
  'Ninh Bình': { vi: 'Ninh Bình', bn: 'নিন বিনহ' },
  'Hải Dương': { vi: 'Hải Dương', bn: 'হাই দুয়ং' },
  'Hải Phòng': { vi: 'Hải Phòng', bn: 'হাই ফং' },
  'Việt Nam': { vi: 'Việt Nam', bn: 'ভিয়েতনাম' },

  // Industries
  'May mặc': { vi: 'May mặc', bn: 'পোশাক শিল্প' },
  'Dệt may': { vi: 'Dệt may', bn: 'টেক্সটাইল এবং গার্মেন্টস' },
  'Xây dựng': { vi: 'Xây dựng', bn: 'নির্মাণ' },

  // Genders
  'Nam': { vi: 'Nam', bn: 'পুরুষ' },
  'Nữ': { vi: 'Nữ', bn: 'মহিলা' },
  'Cả nam và nữ': { vi: 'Cả nam và nữ', bn: 'পুরুষ এবং মহিলা উভয়ই' },

  // Phrases & Stats
  'Không giới hạn': { vi: 'Không giới hạn', bn: 'সীমাহীন' },
  'tuổi': { vi: 'tuổi', bn: 'বছর' },
  'người': { vi: 'người', bn: 'জন' },
  'vòng': { vi: 'vòng', bn: 'রাউন্ড' },
  'trẻ': { vi: 'trẻ', bn: 'শিশু' },
  'Có tăng ca': { vi: 'Có tăng ca', bn: 'ওভারটাইম আছে' },
  'Miễn phí đào tạo': { vi: 'Miễn phí đào tạo', bn: 'বিনামূল্যে প্রশিক্ষণ' },
  'Đào tạo miễn phí': { vi: 'Đào tạo miễn phí', bn: 'বিনামূল্যে প্রশিক্ষণ' },
  'Đào tạo tại chỗ miễn phí': { vi: 'Đào tạo tại chỗ miễn phí', bn: 'বিনামূল্যে অন-সাইট প্রশিক্ষণ' },
  'Miễn phí chỗ ở': { vi: 'Miễn phí chỗ ở', bn: 'বিনামূল্যে আবাসন' },
  'Miễn phí xe đưa đón': { vi: 'Miễn phí xe đưa đón', bn: 'বিনামূল্যে শাটল বাস' },
  'Theo luật Việt Nam': { vi: 'Theo luật Việt Nam', bn: 'ভিয়েতনামের আইন অনুযায়ী' },
  'Có y tế (theo luật Việt Nam)': { vi: 'Có y tế (theo luật Việt Nam)', bn: 'চিকিৎসা সুবিধা আছে (ভিয়েতনামের আইন অনুযায়ী)' },
  'Miễn phí (1 USD/bữa)': { vi: 'Miễn phí (1 USD/bữa)', bn: 'বিনামূল্যে (১ ডলার/খাবার)' },
  'Miễn phí (trưa và ăn nhẹ)': { vi: 'Miễn phí (trưa và ăn nhẹ)', bn: 'বিনামূল্যে (দুপুর এবং বিকেলের জলখাবার)' },
  'Miễn phí (4 USD/ngày)': { vi: 'Miễn phí (4 USD/ngày)', bn: 'বিনামূল্যে (৪ ডলার/দিন)' },
  '2 USD/trẻ/tháng': { vi: '2 USD/trẻ/tháng', bn: '২ ডলার/শিশু/মাস' },
  'Lao động phổ thông': { vi: 'Lao động phổ thông', bn: 'সাধারণ শ্রমিক' },
  'Lao động nước ngoài tại VN': { vi: 'Lao động nước ngoài tại VN', bn: 'ভিয়েতনামে বিদেশী শ্রমিক' },
  'XKLĐ Việt Nam': { vi: 'XKLĐ Việt Nam', bn: 'ভিয়েতনাম শ্রমিক রপ্তানি' },

  // Job Titles
  'Công nhân: May, may máy, cắt (NHÀ MÁY 1)': { vi: 'Công nhân: May, may máy, cắt (NHÀ MÁY 1)', bn: 'শ্রমিক: সেলাই এবং কাটা (কারখানা ১)' },
  'Công nhân: May (NHÀ MÁY 2)': { vi: 'Công nhân: May (NHÀ MÁY 2)', bn: 'শ্রমিক: সেলাই (কারখানা ২)' },
  'Công nhân: Sắt, bê tông, xây (NHÀ MÁY 3)': { vi: 'Công nhân: Sắt, bê tông, xây (NHÀ MÁY 3)', bn: 'শ্রমিক: লোহা, কংক্রিট, নির্মাণ (কারখানা ৩)' },

  // Mock Descriptions (HTML)
  '<p>Làm việc tại dây chuyền may hiện đại. Môi trường chuyên nghiệp, sạch sẽ.</p>': {
    vi: '<p>Làm việc tại dây chuyền may hiện đại. Môi trường chuyên nghiệp, sạch sẽ.</p>',
    bn: '<p>আধুনিক সেলাই লাইনে কাজ। পেশাদার এবং পরিষ্কার পরিবেশ।</p>'
  },
  '<p>Chuyên sản xuất hàng may mặc xuất khẩu. Ưu tiên các ứng viên có tay nghề.</p>': {
    vi: '<p>Chuyên sản xuất hàng may mặc xuất khẩu. Ưu tiên các ứng viên có tay nghề.</p>',
    bn: '<p>রপ্তানি পোশাক উৎপাদনে বিশেষজ্ঞ। দক্ষ প্রার্থীদের অগ্রাধিকার দেওয়া হবে।</p>'
  },
  '<p>Địa điểm thi công các công trình trọng điểm. Cung cấp đầy đủ đồ bảo hộ lao động.</p>': {
    vi: '<p>Địa điểm thi công các công trình trọng điểm. Cung cấp đầy đủ đồ bảo hộ lao động.</p>',
    bn: '<p>গুরুত্বপূর্ণ নির্মাণাধীন এলাকা। সম্পূর্ণ সুরক্ষা সরঞ্জাম সরবরাহ করা হবে।</p>'
  },

  // Requirements & Benefits
  'Sức khỏe tốt, chăm chỉ, có ý thức kỷ luật.': { vi: 'Sức khỏe tốt, chăm chỉ, có ý thức kỷ luật.', bn: 'ভালো স্বাস্থ্য, কঠোর পরিশ্রমী এবং শৃঙ্খলাপরায়ণ।' },
  'Tỉ mỉ, cẩn thận, có thể làm việc theo ca.': { vi: 'Tỉ mỉ, cẩn thận, có thể làm việc theo ca.', bn: 'সতর্ক, মনোযোগী এবং শিফটে কাজ করতে সক্ষম।' },
  'Sức khỏe tốt, chịu được áp lực công việc chân tay nặng nhọc.': { vi: 'Sức khỏe tốt, chịu được áp lực công việc chân tay nặng nhọc.', bn: 'ভালো স্বাস্থ্য এবং ভারী শারীরিক পরিশ্রম করার ক্ষমতা।' },
  'Bảo hiểm theo luật VN, trợ cấp độc hại, thâm niên.': { vi: 'Bảo hiểm theo luật VN, trợ cấp độc hại, thâm niên.', bn: 'ভিয়েতনামের আইন অনুযায়ী বীমা, ঝুঁকি ভাতা এবং অভিজ্ঞতার সুযোগ।' },
  'Môi trường thân thiện, thưởng lễ tết.': { vi: 'Môi trường thân thiện, thưởng lễ tết.', bn: 'বন্ধুসুলভ পরিবেশ, উৎসব বোনাস।' },
  'Phụ cấp công trình, bảo hiểm tai nạn 24/24.': { vi: 'Phụ cấp công trình, bảo hiểm tai nạn 24/24.', bn: 'নির্মাণ ভাতা, ২৪/২৪ দুর্ঘটনা বীমা।' },
  'TOEIC +400 hoặc Giao tiếp: Trung bình': { vi: 'TOEIC +400 hoặc Giao tiếp: Trung bình', bn: 'TOEIC +400 বা যোগাযোগ: মাঝারি' },
  '165cm (Nam) - 152cm (Nữ)': { vi: '165cm (Nam) - 152cm (Nữ)', bn: '১৬৫ সেমি (পুরুষ) - ১৫২ সেমি (মহিলা)' },
  '54kg (Nam) - 42kg (Nữ)': { vi: '54kg (Nam) - 42kg (Nữ)', bn: '৫৪ কেজি (পুরুষ) - ৪২ কেজি (মহিলা)' },
  'Ưu tiên người có kinh nghiệm': { vi: 'Ưu tiên người có kinh nghiệm', bn: 'অভিজ্ঞ প্রার্থীদের অগ্রাধিকার' },
  'Không yêu cầu kinh nghiệm': { vi: 'Không yêu cầu kinh nghiệm', bn: 'অভিজ্ঞতার প্রয়োজন নেই' },
  'Kháng thể viêm gan B: Có': { vi: 'Kháng thể viêm gan B: Có', bn: 'হেপাটাইটিস বি অ্যান্টিবডি: আছে' },
  'Kháng thể viêm gan B: Không': { vi: 'Kháng thể viêm gan B: Không', bn: 'হেপাটাইটিস বি অ্যান্টিবডি: নেই' },

  // Hover Card Sales Manager
  'MASTER_CTV': { vi: 'Tổng đối tác', bn: 'মাস্টার অংশীদার' },
  'company': { vi: 'Công ty', bn: 'কোম্পানি' },
  'location_short': { vi: 'Địa điểm', bn: 'অবস্থান' },
  'successful_candidates': { vi: 'Ứng viên thành công', bn: 'সফল প্রার্থী' },
  'candidates': { vi: 'ứng viên', bn: 'প্রার্থী' },
  'view_full_profile': { vi: 'Xem hồ sơ đầy đủ', bn: 'পূর্ণাঙ্গ প্রোফাইল দেখুন' },
  'additional_information': { vi: 'Thông tin bổ sung', bn: 'অতিরিক্ত তথ্য' },
  'other_foodAllowance': { vi: 'Trợ cấp ăn uống', bn: 'খাবার ভাতা' },
  'other_medicalSupport': { vi: 'Hỗ trợ y tế', bn: 'চিকিৎসা সহায়তা' },
  'other_workingDaysPerWeek': { vi: 'Số ngày làm việc/tuần', bn: 'প্রতি সপ্তাহে কর্মদিবস' },
  'other_workingHoursPerDay': { vi: 'Số giờ làm việc/ngày', bn: 'প্রতিদিন কাজের সময়' },
  'other_workShifts': { vi: 'Ca làm việc', bn: 'কাজের শিফট' },
  'other_housing': { vi: 'Chỗ ở', bn: 'আবাসন' },
  'other_utilities': { vi: 'Điện nước', bn: 'ইউটিলিটি (বিদ্যুৎ/পানি)' },
  'other_transportation': { vi: 'Phương tiện đi lại', bn: 'যাতায়াত ব্যবস্থা' },
  'other_annualLeave': { vi: 'Nghỉ phép năm', bn: 'বার্ষিক ছুটি' },
  'other_legalizationFee': { vi: 'Phí hợp pháp hóa', bn: 'লিগ্যালাইজেশন ফি' },
  'other_contractTerm': { vi: 'Thời hạn hợp đồng', bn: 'চুক্তির মেয়اد' },
  'other_visaFee': { vi: 'Phí Visa', bn: 'ভিসা ফি' },
  'other_airTicket': { vi: 'Vé máy bay', bn: 'বিমান টিকিট' },
  'other_airTicket_arrival_condition': { vi: 'Điều kiện vé chiều đi', bn: 'আগমনের বিমান টিকিটের শর্ত' },
  'other_airTicket_return_condition': { vi: 'Điều kiện vé chiều về', bn: 'প্রত্যাবর্তনের বিমান টিকিটের শর্ত' },
  'labelOther_foodAllowance': { vi: 'Trợ cấp ăn uống', bn: 'খাবার ভাতা' },
  'labelOther_medicalSupport': { vi: 'Hỗ trợ y tế', bn: 'চিকিৎসা সহায়তা' },
  'labelOther_workingDaysPerWeek': { vi: 'Số ngày làm việc/tuần', bn: 'প্রতি সপ্তাহে कर्मদিবস' },
  'labelOther_workingHoursPerDay': { vi: 'Số giờ làm việc/ngày', bn: 'প্রতিদিন কাজের সময়' },
  'labelOther_workShifts': { vi: 'Ca làm việc', bn: 'کাজের শিফট' },
  'labelOther_housing': { vi: 'Chỗ ở', bn: 'আবাসন' },
  'labelOther_utilities': { vi: 'Điện nước', bn: 'ইউটিলিটি (বিদ্যুৎ/পানি)' },
  'labelOther_transportation': { vi: 'Phương tiện đi lại', bn: 'যাতায়াত ব্যবস্থা' },
  'labelOther_visaFee': { vi: 'Phí Visa', bn: 'ভিসা ফি' },
  'labelOther_legalizationFee': { vi: 'Phí hợp pháp hóa', bn: 'লিগ্যালাইজেশন ফি' },
  'labelOther_contractTerm': { vi: 'Thời hạn hợp đồng', bn: 'চুক্তির মেয়াদ' },
  'labelOther_annualLeave': { vi: 'Nghỉ phép năm', bn: 'বার্ষিক ছুটি' },
  'Người lao động tự chi trả': { vi: 'Người lao động tự chi trả', bn: 'শ্রমিক নিজেই বহন করবেন' },
  'Do người sử dụng lao động cung cấp': { vi: 'Do người sử dụng lao động cung cấp', bn: 'নিয়োগকর্তা প্রদান করবেন' },
  'Do người sử dụng lao động hỗ trợ': { vi: 'Do người sử dụng lao động hỗ trợ', bn: 'নিয়োগকর্তা সহায়তা করবেন' },
  '5 ngày/tuần': { vi: '5 ngày/tuần', bn: '৫ দিন/সপ্তাহ' },
  '5.5 ngày/tuần': { vi: '5.5 ngày/tuần', bn: '৫.৫ দিন/সপ্তাহ' },
  '6 ngày/tuần': { vi: '6 ngày/tuần', bn: '৬ ngày/সপ্তাহ' },
  '8 giờ/ngày': { vi: '8 giờ/ngày', bn: '৮ ঘণ্টা/দিন' },
  '8h 48p / ngày': { vi: '8h 48p / ngày', bn: '৮ ঘণ্টা ৪৮ মিনিট/দিন' },
  '12 giờ/ngày': { vi: '12 giờ/ngày', bn: '১২ ঘণ্টা/দিন' },
  'Linh hoạt (theo ca)': { vi: 'Linh hoạt (theo ca)', bn: 'নমনীয় (শিফট অনুযায়ী)' },
  'Ca hành chính (08:00 - 17:00)': { vi: 'Ca hành chính (08:00 - 17:00)', bn: 'অফিস শিফট (০৮:০০ - ১৭:০০)' },
  'Theo quy định của công ty': { vi: 'Theo quy định của công ty', bn: 'কোম্পানির নিয়ম অনুযায়ী' },
  'Theo luật lao động Việt Nam': { vi: 'Theo luật lao động Việt Nam', bn: 'ভিয়েতনামের শ্রম আইন অনুযায়ী' },
};
